import "./Footer.scss"


export default function Footer() {
  return (
    <footer>Footer</footer>
  )
}